// src/components/TriggerTester.tsx
import React, { useState } from "react";
import { normalize } from "../logic/trigger-matcher";

interface TriggerTesterProps {
  // kept for compatibility; not used
  onTestTrigger: (text: string) => void;
}

/**
 * v66 — Simplified Trigger Tester
 * - Always routes tests to Live via window event (exact same matcher as Live).
 * - Dev/Advanced panel and gates are removed from UI.
 * - Console is quiet by default.
 * - No changes to Live, audio, or matcher code paths.
 */
export default function TriggerTester(_: TriggerTesterProps) {
  const [txt, setTxt] = useState("");

  function runTest() {
    const inputRaw = (txt || "").trim();
    if (!inputRaw) return;

    // Mirror Live: optionally compute a normalized preview (not logged), then relay raw text to Live.
    // Keeping normalize import ensures parity without adding console noise.
    void normalize(inputRaw); // no-op usage to keep parity and satisfy isolatedModules

    window.dispatchEvent(
      new CustomEvent("cueboard:test-trigger", { detail: { text: inputRaw } })
    );
  }

  return (
    <div style={{ margin: "8px 0" }}>
      <label className="label" htmlFor="trigger-test-input">
        Test a trigger phrase
        <span className="muted small" style={{ marginLeft: 6 }}>
          (e.g., “can you walk me through your background?”)
        </span>
      </label>

      <input
        id="trigger-test-input"
        className="input"
        placeholder="Type a trigger phrase to test"
        value={txt}
        onChange={(e) => setTxt(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") runTest();
        }}
      />

      <div className="actions" style={{ marginTop: 8 }}>
        <button className="button button-secondary" onClick={runTest}>
          Test Trigger
        </button>
      </div>
    </div>
  );
}
